import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import Notifications from 'client/components/Notifications'
import NavBar from 'client/components/NavBar'
import Spinner from 'client/components/Spinner'
import { ListLink } from 'client/components/NavLink'
import actions from 'client/actions'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DescriptionIcon from '@material-ui/icons/Description';
import ArchiveIcon from '@material-ui/icons/Archive';
import GroupIcon from '@material-ui/icons/Group';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';

class AdminWrapper extends Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    logout: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor (props) {
    super(props)
    this.onClickLogout = this.onClickLogout.bind(this)
  }

  onClickLogout (ev) {
    ev.preventDefault()
    const { dispatch, logout } = this.props
    dispatch(logout())
  }

  render () {
    const { children, classes, role } = this.props

    return (
      <div className={classes.root}>

        <Spinner />

        <NavBar>
            <ListLink to="/admin/plans">
            <div className={classes.navItem}>
                <ListAltIcon color="secondary" />
                Driftsplaner
            </div>
            </ListLink>
            <ListLink to="/admin/portfolios">
            <div className={classes.navItem}>
                <ListAltIcon color="secondary" />
                Porteføljer
            </div>
            </ListLink>
            <ListLink to="/admin/part-templates">
            <div className={classes.navItem}>
                <DescriptionIcon color="secondary" />
                Standarder
            </div>
            </ListLink>
            <ListLink to="/admin/system-texts">
            <div className={classes.navItem}>
                <ArchiveIcon color="secondary" />
                System
            </div>
            </ListLink>
            <ListLink to="/admin/faq">
            <div className={classes.navItem}>
                <LiveHelpIcon color="secondary" />
                FAQ
            </div>
            </ListLink>
            <ListLink to="/admin/users">
            <div className={classes.navItem}>
                <GroupIcon color="secondary" />
                Brugerstyring
            </div>
            </ListLink>
          </NavBar>
          <Notifications />
          <div className={classes.container}>
            { children }
          </div>
        </div>
      )

  }
}

const mapStateToProps = state => {
  return {
    role: state.auth.role,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    logout: actions.logout,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AdminWrapper))
